import React, { useState } from 'react';
import ASSET_PATHS from '../../../assets/config/assetPaths';
import { ImSpinner2 } from 'react-icons/im';

interface BlockConfirmationModalProps {
    isOpen: boolean;
    isSkipMode?: boolean;
    onClose: () => void;
    onConfirm: () => Promise<void>;
    message?: string;
}

const BlockConfirmationModal: React.FC<BlockConfirmationModalProps> = ({ isOpen, isSkipMode = true, onClose, onConfirm, message = 'Are you sure you want to skip this item?'}) => {
    const [isSkipping, setIsSkipping] = useState(false);

    if (!isOpen) return null;

    const handleSkip = async () => {
        setIsSkipping(true);
        await onConfirm();
        setIsSkipping(false);
    };

    return (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex justify-center items-center z-50">
            <div className="relative w-[92%] bg-white p-3 rounded-lg shadow-lg max-w-sm flex flex-col items-center">
                <button
                    className="absolute top-[0.8rem] left-2 text-gray-500 hover:text-gray-700"
                    onClick={onClose}
                >
                    <img src={ASSET_PATHS.closeIcon} alt="Close Icon" />
                </button>
                <h2 className="w-4/5 text-xl text-textPrimary font-normal mb-2 text-center pb-2">
                 {message} 
                </h2>
                {isSkipMode && <img src={ASSET_PATHS.blockIconBlue} alt="Skip Icon" className="h-12 w-12 mb-4" />}
                <div className="flex-col justify-center mt-4 w-full">
                    <button
                        className="bg-primary mb-3 text-white w-full py-3 rounded-lg font-semibold"
                        onClick={handleSkip}
                        disabled={isSkipping}
                    >
                        {isSkipping ? (
                            <div className='py-1 flex justify-center'>
                                <ImSpinner2 className="animate-spin mr-2" />
                            </div>
                        ) : (
                            'Yes'
                        )}
                    </button>
                    <button
                        className="w-full py-3 rounded-lg font-semibold border-2 text-primary border-primary"
                        onClick={onClose}
                    >
                        No
                    </button>
                </div>
            </div>
        </div>
    );
};

export default BlockConfirmationModal;
